import { Outlet, createFileRoute, notFound } from "@tanstack/react-router";
import { TopBar } from "@/components/top-bar";
// blog-langs, not blog-posts: `beforeLoad` is not code-split, so importing from the
// corpus module here put all 967 KB of posts in the chunk every page preloads.
import { isBlogLang } from "@/lib/blog-langs";

export const Route = createFileRoute("/$lang/blog")({
  beforeLoad: ({ params }) => {
    if (!isBlogLang(params.lang)) throw notFound();
  },
  component: LocalizedBlogLayout,
});

function LocalizedBlogLayout() {
  return (
    <div className="min-h-screen bg-background">
      <TopBar />
      <Outlet />
    </div>
  );
}
